<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        大连海大智龙科技有限公司荣获第五届大连市科技创业大赛二等奖
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
        <div class="div-text-left news-Regular-14b6">
            <span>2020-01-04</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
          <p class="indentation">
          2019第八届中国创新创业大赛（大连赛区）暨第五届大连科技创业大赛自2019年4月启动以来，现已正式结束。1月4日，大赛颁奖典礼在大连新闻传媒集团600平演播厅举行，向大连创新力量致敬。
        </p>
        
      </div>
      <div class="div-row div-bottom30">
        <div class="  div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news2/news1.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom30">
        <p class="indentation">
           第五届大连市科技创业大赛启动以来，按照初创企业组和成长企业组分别进行比赛，设新能源及节能环保、先进制造、互联网、生物医药、新材料、电子信息六大行业，征集科技企业报名参赛634家。参赛数量、项目质量创历届新高。通过审核，495家企业进入初赛，经过初赛、复赛、决赛的严格评审后，最终每个行业产生成长企业组一等奖1名、二等奖2名、三等奖3名，初创企业组一、二、三等奖各1名，总计54家企业获奖。大连赛区推荐了29家企业代表大连参加全国行业总决赛，有8家企业荣获优秀企业奖，彰显大连创业风采。
        </p>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news2/news2.jpg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  img {
    vertical-align: middle;
    border-style: none;
    width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news2.vue